import "./App.css";
import React from "react";
import TenKenRoutes from "./routes";
import { Provider } from "react-redux";
import store from "./store";

function App() {
  return (
      <Provider store={store}>
        <TenKenRoutes />
      </Provider>
  );
}

export default App;